import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

const GalleryPopup = ({ images, onClose }) => {
  const { t } = useTranslation();

  if (!images) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30 bg-black/50">
      <div className="w-full max-w-lg md:max-w-[80%] lg:max-w-[800px] p-6 mx-4 bg-white rounded-lg shadow-xl md:mx-0">
        <div className="flex justify-between mb-4">
          <h2 className="text-lg font-bold text-black">
            {t("ProductPictures")}
          </h2>
          <button onClick={onClose}>
            <XMarkIcon className="w-6 h-6 text-black" />
          </button>
        </div>

        <div className="h-[45vh] overflow-y-auto">
          <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
            {images.map((img, index) => (
              <div
                key={index}
                className="w-full h-48 overflow-hidden border rounded-lg"
              >
                <a
                  href={img}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full h-full"
                >
                  <img
                    src={img}
                    alt={`Gallery image ${index + 1}`}
                    className="object-cover w-full h-full"
                  />
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GalleryPopup;
